module.exports = __webpack_public_path__ + "img/ss.b765e425.svg";